import { FormField } from "@/components/elements/FormField/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Textarea } from "@/components/elements/Textarea";
import { TLearnerNotesForm } from "@/features/learning-progress/schema/useLearnerNotesSchema";
import { black, divider } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type TProps = {
  readOnly?: boolean;
  title?: string;
  subtitle?: string;
};

export const SupportOrgMemoEditSection: FC<TProps> = ({ readOnly = false, title, subtitle }) => {
  const { control } = useFormContext<TLearnerNotesForm>();

  return (
    <InnerBox
      p={3}
      showDivider={false}
      borderColor={divider.high}
      bordered
      title={title}
    >
      <Stack mt={1} gap={1}>
        {subtitle && (
          <Typography variant="cap12" color={black[70]}>
            {subtitle}
          </Typography>
        )}
        <FormField control={control} name="rsoMemo" noLabel>
          <Textarea readonly={readOnly} placeholder="入力してください" minRows={5} maxRows={10} />
        </FormField>
      </Stack>
    </InnerBox>
  );
};
